/* Bubbly: "Ver mais artigos" nas coleções (snippets/bubbly-ver-mais.liquid) */
(function () {
  if (customElements.get('bubbly-ver-mais')) return;

  var restaurado = false; // a restauração da posição só acontece uma vez por carregamento de página

  // Chave da lista: coleção + filtros + ordenação, sem o número da página
  function chave() {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    return 'bubbly-vm:' + location.pathname + '?' + params.toString();
  }

  function paginaDe(url) {
    return parseInt(new URL(url, location.origin).searchParams.get('page'), 10) || 1;
  }

  function voltouAtras() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return nav ? nav.type === 'back_forward' : performance.navigation && performance.navigation.type === 2;
  }

  customElements.define(
    'bubbly-ver-mais',
    class extends HTMLElement {
      connectedCallback() {
        this.paginaInicial = parseInt(this.dataset.pagina, 10) || 1;
        this.ultimaPagina = this.paginaInicial;
        this.ligar();

        // Guardar quantas páginas estão carregadas e a posição, ao sair para um produto
        this.guardar = this.guardar.bind(this);
        window.addEventListener('pagehide', this.guardar);

        if (!restaurado) {
          restaurado = true;
          this.restaurar();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('pagehide', this.guardar);
      }

      ligar() {
        var self = this;
        this.botao = this.querySelector('[data-ver-mais]');
        if (!this.botao) return;
        this.botao.addEventListener('click', function (event) {
          event.preventDefault();
          self.carregar(self.botao.href, true);
        });
      }

      // Coleções: #product-grid é a própria lista. Pesquisa: #product-grid é o contentor e a lista está dentro (ul).
      contentor() {
        return document.getElementById('product-grid');
      }

      grelha() {
        var c = this.contentor();
        if (!c) return null;
        return c.tagName === 'UL' ? c : c.querySelector('ul.product-grid') || c;
      }

      carregar(url, focar) {
        var self = this;
        var grelha = this.grelha();
        if (!grelha) return Promise.resolve();

        if (this.botao) {
          this.botao.setAttribute('aria-busy', 'true');
          this.botao.textContent = (window.bubblyTextos && window.bubblyTextos.aCarregar) || 'A carregar…';
        }

        var pedido = new URL(url, location.origin);
        pedido.searchParams.set('section_id', this.contentor().dataset.id);

        return fetch(pedido.toString())
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var novos = Array.prototype.slice.call(
              doc.querySelectorAll('#product-grid > .grid__item, #product-grid > ul.product-grid > .grid__item')
            );
            var primeiro = null;

            novos.forEach(function (item) {
              // Os artigos novos não passam pela animação de entrada do Dawn (ficariam invisíveis)
              item.classList.remove('scroll-trigger', 'animate--slide-in');
              item.removeAttribute('data-cascade');
              var adotado = document.importNode(item, true);
              grelha.appendChild(adotado);
              if (!primeiro) primeiro = adotado;
            });

            self.ultimaPagina = paginaDe(url);

            // Atualizar contagem, barra e botão com os do bloco seguinte
            var seguinte = doc.querySelector('bubbly-ver-mais');
            if (seguinte) {
              self.innerHTML = seguinte.innerHTML;
              self.ligar();
            }

            if (focar && primeiro) {
              var link = primeiro.querySelector('a[href]');
              if (link) link.focus({ preventScroll: true });
            }
          })
          .catch(function () {
            // Em caso de erro, segue o link normalmente (página seguinte)
            location.href = url;
          });
      }

      guardar() {
        try {
          sessionStorage.setItem(
            chave(),
            JSON.stringify({ inicial: this.paginaInicial, ultima: this.ultimaPagina, y: window.scrollY })
          );
        } catch (e) {}
      }

      restaurar() {
        var estado = null;
        try {
          estado = JSON.parse(sessionStorage.getItem(chave()) || 'null');
        } catch (e) {}

        if (!voltouAtras() || !estado || estado.inicial !== this.paginaInicial || estado.ultima <= this.paginaInicial) {
          return;
        }

        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        var self = this;
        var base = new URL(location.href);
        var pagina = this.paginaInicial;

        // Carregar as páginas em falta por ordem e voltar à posição guardada
        (function proxima() {
          if (pagina >= estado.ultima || !self.botao) {
            window.scrollTo(0, estado.y);
            return;
          }
          pagina += 1;
          base.searchParams.set('page', pagina);
          self.carregar(base.toString(), false).then(proxima);
        })();
      }
    }
  );
})();
